import React, { useState, useCallback } from 'react'

import CreditCardForm from './CreditCardForm'
import { Radio } from 'components/ui'
import WireTransferForm from './WireTransferForm'

const PaymentSummary = ({ selectedPackage, termsOfUseContent }) => {
    const [paymentMethod, setPaymentMethod] = useState('credit')

    const onChange = useCallback((val) => {
        setPaymentMethod(val)
    }, [])

    return (
        <div className="flex flex-col gap-10 pb-10">
            <div className="flex flex-col gap-10">
                <h5>Payment Summary</h5>
                <div>
                    <div className="font-medium text-black text-base">
                        Payment Method
                    </div>
                    <div className="mt-4">
                        <Radio.Group
                            vertical
                            value={paymentMethod}
                            onChange={onChange}
                        >
                            <Radio
                                value={'credit'}
                                className={
                                    paymentMethod === 'credit'
                                        ? 'text-red-500 font-medium'
                                        : 'text-zinc-500'
                                }
                            >
                                Credit Card
                            </Radio>
                            {/* <Radio value={'paypal'} disabled>
                                Paypal
                            </Radio> */}
                            <Radio
                                value={'wire'}
                                className={
                                    paymentMethod === 'wire'
                                        ? 'text-red-500 font-medium'
                                        : 'text-zinc-500'
                                }
                            >
                                Wire Transfer
                            </Radio>
                        </Radio.Group>
                    </div>
                </div>
            </div>
            {paymentMethod === 'credit' && (
                <CreditCardForm selectedPackage={selectedPackage} termsOfUseContent={termsOfUseContent} />
            )}
            {paymentMethod === 'wire' && (
                <WireTransferForm selectedPackage={selectedPackage} termsOfUseContent={termsOfUseContent} />
            )}
        </div>
    )
}

export default PaymentSummary
